import React, { Component } from 'react';
import { Link, withRouter } from 'react-router'
import JumpingMan from '../home/images/JumpingMan'
import backgroundImg from '../../images/background.jpg'

const style = {
	'backgroundImage': `url('${backgroundImg}')`
}

class PracticeYay extends Component {
	render() {
		const { routeParams } = this.props
		return (
			<div className="jumping-yay" style={style}>
				<center>
					<JumpingMan />
					<h5>Thank you for joining</h5>
					<div className="md-subhead">You will be assigned a profile shortly</div>
					<br />
					<Link to={`/practice/${routeParams.name}/`}>
						<button className="md-button md-accent shadow-2" onClick={this.closeYay}>Ok</button>
					</Link>
				</center>
			</div>
		);
	}
};

export default withRouter(PracticeYay);


// WEBPACK FOOTER //
// ./src/components/practice/PracticeYay.jsx